/**
 * SEO記事の「どの章の、どのボタンが押されたか」と「どの章まで読まれたか」の計測（2026-10）
 *
 * 出すイベント（Shopify.analytics.publish。GA4 へはカスタムピクセルが転送する）
 *   article_click         記事内のリンク・ボタンが押された
 *   article_chapter_view  章が初めて画面に入った（1章につき1ページビュー1回）
 *
 * 既存の egift-okurikata.js のイベント（article_card_cta など）はそのまま残す。
 * こちらは全配置を1つのイベント名にまとめ、章番号を必ず付けるためのもの。
 * GA4 にはこちらの2つだけを送る（二重計上しない）。
 *
 * パラメータ（GA4 の文字数上限100に合わせて切る）
 *   article_handle   記事のハンドル
 *   placement        押された場所（下の一覧）
 *   chapter_no       押された章の番号。記事上部・固定バー・目次などは 0
 *   target_chapter_no  一覧・目次から章へ飛ぶリンクの飛び先の章番号（それ以外は 0）
 *   chapter_id       章のハンドル（押された章、無ければ飛び先の章）
 *   chapter_heading  章の見出し
 *   product_handle   リンク先の商品ハンドル（/products/◯◯ のとき。見積もりリンクは ?product= の値）
 *   link_type        pdp（商品ページ）／quote（見積もりページ）／anchor（記事内移動）／button／other
 *   total_chapters   記事内の章の数
 *
 * placement の値
 *   okurikata        記事上部の贈り方ブロック
 *   chip             一覧の絞り込みチップ
 *   carousel         一覧（カルーセル）のアイテム
 *   card_choosable   カードの「相手に◯◯を選んでもらう」
 *   card_detail      カードの「詳しく見る」「商品を詳しく見る」
 *   card_quote       法人記事カードの「この商品の見積もり」（2026-10-28 追加）
 *   card_name        カードの商品名
 *   card_image       カードの画像
 *   experience_more  「使ってみて」の…続きを見る
 *   body_link        章の本文中のリンク（法人バナーもここ）
 *   chapter_other    章内のそれ以外
 *   back_to_list     ギフト一覧に戻る
 *   toc              PCの目次
 *   sticky           SPの固定バー
 *   end_cta          記事末尾ブロック
 *   biz              法人記事の相談ボタン（商品のない章の「この商品について相談する」）
 *   intro_link       章より前の記事本文（リード文）のリンク
 */
(function () {
  'use strict';

  if (!document.querySelector('.eg-wrap')) return;

  function publish(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* 計測で画面を壊さない */ }
  }

  function cut(s) {
    s = (s || '').replace(/\s+/g, ' ').trim();
    return s.length > 100 ? s.slice(0, 100) : s;
  }

  var chapters = Array.prototype.slice.call(document.querySelectorAll('.eg-ch'));
  var total = chapters.length;

  var m = location.pathname.match(/\/blogs\/[^/]+\/([^/?#]+)/);
  var articleHandle = m ? decodeURIComponent(m[1]) : '';

  function chapterInfo(sec) {
    if (!sec) return { no: 0, id: '', heading: '' };
    var h = sec.querySelector('.eg-ch__h');
    return {
      no: chapters.indexOf(sec) + 1,
      id: (sec.id || '').replace(/^eg-/, ''),
      heading: cut(h ? h.textContent : '')
    };
  }

  function placementOf(el) {
    if (el.closest('.eg-ok')) return 'okurikata';
    if (el.closest('.eg-chips')) return 'chip';
    if (el.closest('.eg-list')) return 'carousel';
    if (el.closest('.eg-sticky')) return 'sticky';
    if (el.closest('.eg-toc')) return 'toc';
    if (el.closest('.eg-end')) return 'end_cta';
    if (el.closest('.eg-biz-cta') || el.hasAttribute('data-eg-biz-open')) return 'biz';
    if (el.closest('.eg-back-to-list')) return 'back_to_list';
    if (el.closest('.eg-card')) {
      if (el.classList.contains('eg-card__media')) return 'card_image';
      if (el.closest('.eg-card__name')) return 'card_name';
      if (el.getAttribute('data-eg-card-cta') === 'choosable') return 'card_choosable';
      if (el.getAttribute('data-eg-card-cta') === 'quote') return 'card_quote';
      return 'card_detail';
    }
    if (el.closest('.eg-exp')) return 'experience_more';
    if (el.closest('.eg-ch__body')) return 'body_link';
    if (el.closest('.eg-ch')) return 'chapter_other';
    return 'intro_link';
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a[href], button') : null;
    if (!el) return;
    // 記事の外（ヘッダー・フッター・パンくず）は数えない
    if (!el.closest('.eg-wrap, .eg-sticky, .article-template__content, .article-template .rte')) return;

    var placement = placementOf(el);
    var here = chapterInfo(el.closest('.eg-ch'));

    var href = el.tagName === 'A' ? (el.getAttribute('href') || '') : '';
    var linkType = 'button';
    var productHandle = '';
    var target = { no: 0, id: '', heading: '' };

    if (href) {
      var pm = href.match(/\/products\/([^/?#]+)/);
      if (href.indexOf('/pages/corporate-quote') > -1) {
        linkType = 'quote';
        var qm = href.match(/[?&]product=([^&#]+)/);
        if (qm) productHandle = decodeURIComponent(qm[1]);
      } else if (pm) {
        linkType = 'pdp';
        productHandle = decodeURIComponent(pm[1]);
      } else if (href.charAt(0) === '#') {
        linkType = 'anchor';
        var t = href.length > 1 ? document.getElementById(href.slice(1)) : null;
        if (t && t.classList.contains('eg-ch')) target = chapterInfo(t);
      } else {
        linkType = 'other';
      }
    }
    // カルーセルのアイテムは章内リンクなので、商品は data-product から取る
    if (!productHandle && el.getAttribute('data-product') && placement === 'carousel') {
      productHandle = el.getAttribute('data-product');
    }

    publish('article_click', {
      article_handle: cut(articleHandle),
      placement: placement,
      chapter_no: here.no,
      target_chapter_no: target.no,
      chapter_id: cut(here.id || target.id),
      chapter_heading: here.heading || target.heading,
      product_handle: cut(productHandle),
      link_type: linkType,
      filter: el.getAttribute('data-eg-filter') || el.getAttribute('data-eg-okurikata') || el.getAttribute('data-eg-sticky-btn') || '',
      total_chapters: total
    });
  }, true);

  // ── 章の到達（1ページビューで各章1回だけ）
  if ('IntersectionObserver' in window && total) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var info = chapterInfo(en.target);
        if (seen[info.no]) return;
        seen[info.no] = true;
        io.unobserve(en.target);
        publish('article_chapter_view', {
          article_handle: cut(articleHandle),
          chapter_no: info.no,
          chapter_id: cut(info.id),
          chapter_heading: info.heading,
          total_chapters: total
        });
      });
    }, { threshold: 0, rootMargin: '0px 0px -30% 0px' });
    chapters.forEach(function (c) { io.observe(c); });
  }
})();